import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  FiBarChart2,
  FiBriefcase,
  FiFileText,
  FiGrid,
  FiLayers,
  FiLogOut,
  FiMenu,
  FiPackage,
  FiUser,
  FiUsers,
} from 'react-icons/fi';
import AuthContext from '../context/AuthContext';

const Navbar = () => {
  const { user, logout, isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const adminUser = isAdmin();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', label: 'Dashboard', icon: FiGrid },
    { path: '/sales', label: 'Ventas', icon: FiBriefcase },
    { path: '/platforms', label: 'Plataformas', icon: FiLayers },
    { path: '/products', label: 'Productos', icon: FiPackage },
    { path: '/articles', label: 'Articulos', icon: FiFileText },
    { path: '/conversions', label: 'Conversiones', icon: FiBarChart2 },
  ];

  if (adminUser) {
    menuItems.push({ path: '/admin/users', label: 'Usuarios', icon: FiUsers });
  }

  return (
    <header className="topbar">
      <div className="page-container topbar-shell">
        <div className="topbar-section">
          <div className="dropdown topbar-mobile-menu">
            <label tabIndex={0} className="btn btn-ghost btn-circle">
              <FiMenu size={18} />
            </label>
            <ul tabIndex={0} className="menu menu-sm dropdown-content dropdown-panel w-72 p-2">
              <li className="menu-title px-3 pt-2">Navegacion</li>
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;

                return (
                  <li key={item.path}>
                    <Link to={item.path} className={`dropdown-link ${isActive ? 'active' : ''}`}>
                      <Icon size={16} />
                      <span>{item.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <Link to="/" className="topbar-brand">
            <span className="brand-mark">CEM</span>
            <span className="brand-copy">
              <span className="brand-title">AfiliadosCEM</span>
              <span className="brand-subtitle">Panel operativo</span>
            </span>
          </Link>
        </div>

        <nav className="topbar-desktop-nav nav-list">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive ? 'nav-link-active' : ''}`}
              >
                <Icon className="nav-link-icon" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="topbar-section">
          <div className="topbar-user-copy">
            <span className="topbar-user-label">{adminUser ? 'Administrador' : 'Usuario'}</span>
            <span className="topbar-user-name">{user?.name || 'Cuenta'}</span>
          </div>

          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="user-trigger">
              <span className="user-avatar">{user?.name?.charAt(0).toUpperCase() || 'U'}</span>
            </label>

            <ul tabIndex={0} className="menu menu-sm dropdown-content dropdown-panel w-64 p-2">
              <li className="menu-title px-3 pt-2">Cuenta</li>
              <li>
                <Link to="/profile" className="dropdown-link">
                  <FiUser size={16} />
                  <span>Perfil</span>
                </Link>
              </li>
              <li>
                <button onClick={handleLogout} className="dropdown-link">
                  <FiLogOut size={16} />
                  <span>Cerrar sesion</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
